<template>
  <div class="padding-16">
    <div>
      <textarea
        class="text-content radius"
        maxlength="120"
        cols="30"
        rows="10"
        placeholder="请描述详细的申诉理由，最多120字"
        v-model="text"
      ></textarea>
    </div>
    <div class="bg-white margin-tb-12 radius padding-12">
      <div class="text-grey margin-bottom-12">
        照片上传： {{ imgList.length }} / 9
      </div>
      <van-uploader
        v-model="imgList"
        :before-read="beforeRead"
        :max-size="3072 * 1024"
        :max-count="9"
        :multiple="true"
        @oversize="onOversize"
      />
    </div>

    <div padding-12>
      <van-button type="primary" block :loading="loading" @click="onSubmit"
        >确认提交</van-button
      >
      <div class="text-12 text-grey1 margin-top-8" style="line-height: 1.5em">
        请确认您所提交的投诉信息真实性，否则所带来的一切损失由您承担。最终申诉结果您可以在客服中心-服务进度中查看。
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Uploader } from 'vant'

import { recordAdd, uploadFile } from 'api/service'

Vue.use(Uploader)
export default {
  data () {
    return {
      imgList: [],
      text: '',
      loading: false
    }
  },
  methods: {
    beforeRead (file) {
      const typeList = ['image/jpeg', 'image/png']
      if (!typeList.includes(file.type)) {
        this.$toast('请上传jpg/png格式照片')
        return false
      }
      return true
    },
    onOversize (file) {
      this.$toast('文件大小不能超过3M')
    },
    onSubmit () {
      const { text, imgList } = this
      if (!text) {
        this.$toast('申诉理由不能为空')
        return
      }
      if (!imgList.length) {
        this.$toast('至少上传一张照片')
        return
      }
      this.$dialog
        .confirm({
          title: '投诉提醒',
          message:
            '请根据实际情况进行投诉，平台会根据实际情况进行调查，若恶意投诉会收到平台的追责和惩罚。',
          confirmButtonText: '同意',
          cancelButtonText: '放弃',
          confirmButtonColor: 'var(--primary)',
          cancelButtonColor: 'var(--light-grey1)'
        })
        .then(() => {
          const promiseList = this.imgList.map((item) => {
            return uploadFile(item.file)
          })
          let imgList = []
          this.loading = true
          Promise.all(promiseList)
            .then((res) => {
              imgList = res.map((item) => item.url)
              recordAdd({
                questionOrderId: this.$route.params.id,
                content: text,
                imageUrls: imgList
              })
                .then(() => {
                  this.$toast({
                    type: 'success',
                    message: '提交成功'
                  })
                  this.$dialog
                    .alert({
                      message: '后续进度请在客服中心——服务进度中查看',
                      confirmButtonText: '我知道了',
                      confirmButtonColor: 'var(--primary)'
                    })
                    .then(() => {
                      this.$router.back()
                    })
                }).catch(() => {
                  this.loading = false
                })
            })
            .catch(() => {
              this.$toast('图片上传失败')
              this.loading = false
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.text-content {
  border: none;
  display: block;
  width: 100%;
  padding: 16px;
  resize: none;
}
</style>
